import { AxiosPromise } from 'axios'

import ClientSDK from '../../App/ClientSDK'

export const fetchNotifications = (): AxiosPromise => {
  const url = 'notification-center/notifications/application'

  return ClientSDK.instance().get(url)
}

export const fetchReadNotification = (notificationId: string): AxiosPromise => {
  const url =
    'notification-center/notifications/' + notificationId + '/add-status'

  return ClientSDK.instance().post(url, {
    medium: 'application',
    status: 'read',
  })
}
